import { Machine, assign } from 'xstate';
const BRANCH_VMB = 'VMB';
const BRANCH_KEF = 'KÉF';
// This machine is completely decoupled from Vue
const DEFAULT_CONTEXT = {
	annualIncome: null,
	companyForm: null,
	activity: null,
	name: null,
	email: null,
	phoneNumber: null,
	taxNumber: null,
	bank: null,
	zipCode: null,
	acceptPrivacyStatement: null,
	szepCard: null,
	captchaText: null,
	captchaKey: null
};
export const posStateMachine = Machine(
	{
		id: 'posMachine',
		initial: 'revenue',
		context: Object.assign({}, DEFAULT_CONTEXT),
		states: {
			revenue: {
				entry: ['resetContext'],
				on: {
					'0-50': {
						target: 'szechenyi-card',
						actions: ['setRevenue']
					},
					'51-349': { target: 'company-type', actions: ['setRevenue'] },
					'350-899': { target: 'company-type', actions: ['setRevenue'] },
					'900-': { target: 'offer-custom-company-type', actions: ['setRevenue'] },
					TECHNICAL_ERROR: 'technical-error'
				}
			},
			'szechenyi-card': {
				on: {
					YES: { target: 'offer-book-appointment', actions: ['setSzepCard'] },
					NO: { target: 'offer-simple', actions: ['setSzepCard'] },
					RESET: 'revenue'
				}
			},
			'company-type': {
				exit: ['setCompanyForm'],
				on: {
					COMPANY_TYPE_SELECTED: [{ target: 'offer-custom-company-type', cond: 'isFoundationOrGovernment' }, { target: 'business-activity' }],
					RESET: 'revenue'
				}
			},
			'offer-custom-company-type': {
				on: {
					SEND_OFFER: { target: 'offer-sending', actions: ['setOfferData'] },
					TECHNICAL_ERROR: 'technical-error',
					RESET: 'revenue'
				}
			},
			'offer-simple': {
				on: {
					RESET: 'revenue'
				}
			},
			'offer-book-appointment': {
				on: {
					DOWNLOAD_PDF: 'download-pdf',
					RESET: 'revenue'
				}
			},
			'download-pdf': {
				on: {
					RESET: 'revenue'
				}
			},
			'offer-table': {
				on: {
					GET_OFFER: 'offer-custom-company-type',
					RESET: 'revenue'
				}
			},
			'business-activity': {
				exit: ['setActivity'],
				on: {
					ACTIVITY_SELECTED: [
						{ target: 'offer-custom-company-type', cond: 'isKEF' },
						{ target: 'offer-book-appointment', cond: 'isBranchVMB51349' },
						{ target: 'offer-table', cond: 'isBranchVMB350899' }
					],
					RESET: 'revenue'
				}
			},
			'offer-sending': {
				on: {
					CAPTCHA_ERROR: 'offer-custom-company-type',
					SUCCESS: 'success',
					FAILURE: 'failure',
					RESET: 'revenue'
				}
			},
			success: {
				on: {
					RESET: 'revenue',
					TECHNICAL_ERROR: 'technical-error'
				}
			},
			failure: {
				on: {
					RESET: 'revenue',
					RETRY: 'offer-custom-company-type'
				}
			},
			'technical-error': {
				on: {
					RESET: 'revenue'
				}
			}
		}
	},
	{
		guards: {
			isBranchVMB51349: (context, { classification }) => {
				return context.annualIncome == '51-349' && classification == BRANCH_VMB;
			},
			isBranchVMB350899: (context, { classification }) => {
				return context.annualIncome == '350-899' && classification == BRANCH_VMB;
			},
			isKEF: (context, { classification }) => {
				return classification == BRANCH_KEF;
			},
			isFoundationOrGovernment: (context, { companyForm }) => {
				return companyForm == 'ALAP' || companyForm == 'ONK';
			}
		},
		actions: {
			setRevenue: assign({
				annualIncome: (context, { type }) => {
					return type;
				}
			}),
			setCompanyForm: assign({
				companyForm: (context, { companyForm }) => {
					return companyForm;
				}
			}),
			setActivity: assign({
				activity: (context, { activity }) => {
					return activity;
				}
			}),
			setSzepCard: assign({
				szepCard: (context, { type }) => {
					return type == 'YES';
				}
			}),
			setOfferData: assign((context, { offerData }) => {
				return {
					...context,
					...offerData
				};
			}),
			resetContext: assign(() => {
				return {
					...DEFAULT_CONTEXT
				};
			})
		}
	}
);
